// extracted by mini-css-extract-plugin
module.exports = {"root":"WorkQueuesItem_root__B4BTm","icon":"WorkQueuesItem_icon__2wRgm","label":"WorkQueuesItem_label__V_DSF"};